import { css } from "styled-components";
import { Icon } from "../../../../../Icon";
export const carouselNextPrevRiotProduct = (chroma, paletteTokens) => css `
  ${Icon} {
    background-color: ${paletteTokens.accents1};
  }

  &:hover {
    ${Icon} {
      background-color: ${paletteTokens.accents1_hover};
    }
  }

  &:disabled {
    ${Icon} {
      opacity: 0.7;
      background-color: ${paletteTokens.accents1_disabled};
    }
  }
`;
export const riotProductSkin = (chroma, paletteTokens) => css `
  ${carouselNextPrevRiotProduct(chroma, paletteTokens)}
`;
//# sourceMappingURL=index.js.map